<template>
    <div id="cart-resume">
            Handlevogn ({{ $store.state.cartCount }})

        <div v-if="$store.state.cart.length > 0">
            <div v-for="item in $store.state.cart"
                :key="item.id">
                {{ item.quantity }} x {{ item.name }}
                <a class="float-right text-danger" title="Remove from cart" @click.prevent="removeFromCart(item)">
                    <i class="fa fa-fw fa-trash"></i>
                </a>
            </div>
            <a class="btn-sm btn-primary btn mt-3" @click="checkout">
                Send
            </a>
        </div>
        <div v-else>
            <div>
                Handlekurven er tom
            </div>
            <div class="text-success" v-if="pedidoSent">
                Bestillingen din ble mottatt, takk.
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            pedidoSent: false,
        }
    },
    methods: {
        removeFromCart(item) {
            console.log('removeFrossmCart');
            console.log(item);
            this.$store.commit('removeFromCart', item);
        },
        checkout(){
            console.log('checkout()');
            let that = this;
            let data = {
                cart: JSON.stringify(this.$store.state.cart),
                shop_id: document.getElementById("shop_id").value
            }

            axios.post('/shops/pedido', data)
            .then(function (response) {
                console.log(response);
                if (response.data.success) {
                    that.$store.commit('emptyCart');
                    that.pedidoSent = true;
                } else {
                    alert('Error, contact support.')
                }
              })
              .catch(function (error) {
                console.log(error);
              });
        }
    },
    computed: {
        totalPrice() {
            let total = 0;

            for (let item of this.$store.state.cart) {
                total += item.totalPrice;
            }

            return total.toFixed(2);
        }
    }
}
</script>
